export default ({ authGuard, guestGuard }) => [
    ...guestGuard([
        {
            path: '/login',
            name: 'Login',
            component: () => import(/* webpackChunkName: "home" */ '@/pages/login')
        }
    ]),

    ...authGuard([
        {
            path: '/',
            name: 'Home',
            component: () => import(/* webpackChunkName: "home" */ '@/pages/home')
        },
        {
            path: '/create',
            name: 'Create',
            component: () => import(/* webpackChunkName: "home" */ '@/pages/create')
        }
    ])
];